import { render } from "./Loading.vue?vue&type=template&id=176fd7a0&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=176fd7a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-176fd7a0"

export default script